import { useState } from "react";
import {
    Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import LeadTypePill from "@/components/LeadTypePill";

export default function LeadTypesPickerDialog({
    open, onOpenChange, types, initialSelected = [], onConfirm, title, description, confirmLabel = "Save",
}) {
    const [selected, setSelected] = useState(() => new Set(initialSelected));
    const toggle = (id) => {
        const next = new Set(selected);
        next.has(id) ? next.delete(id) : next.add(id);
        setSelected(next);
    };
    return (
        <Dialog open={open} onOpenChange={(o) => { if (o) setSelected(new Set(initialSelected)); onOpenChange(o); }}>
            <DialogContent data-testid="lead-types-picker">
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                    {description && <DialogDescription>{description}</DialogDescription>}
                </DialogHeader>
                <div className="space-y-2 max-h-72 overflow-y-auto py-1">
                    {types.map(t => (
                        <label
                            key={t.id}
                            className="flex items-center gap-3 px-2 py-1.5 rounded-md hover:bg-gray-50 cursor-pointer"
                            data-testid={`pick-type-${t.id}`}
                        >
                            <Checkbox checked={selected.has(t.id)} onCheckedChange={() => toggle(t.id)} />
                            <LeadTypePill leadType={t} />
                            <span className="text-xs text-muted-foreground ml-auto">{t.lead_count}</span>
                        </label>
                    ))}
                </div>
                <DialogFooter>
                    <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
                    <Button onClick={() => { onConfirm(Array.from(selected)); onOpenChange(false); }} data-testid="picker-confirm">
                        {confirmLabel}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
